export default {
  title: "Undead",
  content: [
    "New ability: Embrace of Undeath: Deal 5% additional damage to targets below 10% health.",
  ],
};
